import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { type ComponentProps, useState } from 'react';

import { cn } from '../../../lib';
import { Input } from '../input';
import { Group } from '@folio/components/ui/flex';

type PasswordInputProps = ComponentProps<typeof Input>;

export const PasswordInput = ({ className, ...rest }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Group align="stretch" gap={0}>
      <Input
        type={showPassword ? 'text' : 'password'}
        {...rest}
        className={cn('rounded-r-none', className)}
      />
      <button
        type="button"
        onClick={() => setShowPassword(v => !v)}
        className="px-2 border border-input rounded-r-md border-l-0"
      >
        {!showPassword ? <EyeIcon /> : <EyeOffIcon />}
      </button>
    </Group>
  );
};
